import { Provider } from 'react-redux';
import { PersistGate, PersistGateProps } from 'redux-persist/integration/react';

import { Store } from './configureStore.js';

export type StoreProviderProps = Partial<Omit<PersistGateProps, 'loading' | 'persistor'>> & {
  store: Store;
  loading?: PersistGateProps['loading'];
};

export const StoreProvider: React.FC<StoreProviderProps> = ({ store, children, loading }) => {
  return (
    <Provider store={store}>
      <PersistGate loading={loading} persistor={store.persistor}>
        {children}
      </PersistGate>
    </Provider>
  );
};

export default StoreProvider;
